<header class="unlogged-header">
  <a class="unlogged-header__brand" href="/" aria-label="NEXT">
    <img src="assets/icons/header/next-gradient.svg" alt="NEXT" class="unlogged-header__logo" />
  </a>
  <div class="unlogged-header__actions">
    <app-language-selector [loginValue]="true"></app-language-selector>
    <div class="unlogged-header__clock">
      <app-clock></app-clock>
    </div>
  </div>
</header>
